import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Button, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import bg from '../../images/edu-bg.png';
import Service from '../Service/Service';

const Home = () => {
    // defining states for services
    const [services, setServices] = useState([]);
    useEffect(() => {
        // fetching data from api
        fetch('./services.JSON')
            .then(res => res.json())
            .then(data => setServices(data))
    }, [])
    return (
        <div>
            <div className="d-flex justify-content-evenly mb-5">
                <div className="mt-5">
                    <h1 className="p-5" style={{ fontSize: "70px" }}> <span style={{ color: 'orange' }}>Learn English</span> Without Limits</h1>
                    <p className="w-75 mx-auto mb-5"> learn english  from certified native teachers and practice English to overcome the fear of speaking, become fluent, and speak like a native speaker. Learn anytime, anywhere.</p>
                    {/*Adding homepage buttons*/}
                    <Link to="/services">
                        <Button className="px-4 py-2 me-4 fw-bold" variant="success">Get Started</Button>
                    </Link>
                    <Link to="/instructors">
                        <Button className="px-4 py-2 fw-bold" variant="outline-success">Book Lesson</Button>
                    </Link>
                </div>
                {/*Adding homepage cover image*/}
                <div>
                    <img className="w-75" src={bg} alt="" />
                </div>
            </div>
            <div>
                <h1 className="fs-1">Our Services</h1>
                < hr className="w-25 mx-auto mb-4 text-dark" />
                {/*Showing services*/}
                <Row xs={1} md={4} className="g-4 mx-5 mb-5 ">
                    {
                        services.filter(service => service.id <= 4).map(service => <Service
                            key={service.id}
                            service={service}></Service>)
                    }
                </Row>
            </div>
        </div>
    );
};

export default Home;